import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { PlayerProvider } from "./context/PlayerContext";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Player from "./components/Player";
import Home from "./pages/Home";
import Order from "./pages/Order";
import PrivateEvents from "./pages/PrivateEvents";
import Business from "./pages/Business";
import Album from "./pages/Album";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Imprint from "./pages/Imprint";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import BankPayment from "./pages/BankPayment";
import AdminPayments from "./pages/AdminPayments";

const TOAST_OPTIONS = { style: { background: "#141620", border: "1px solid #282C3D", color: "#F1F3F9" } };

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <PlayerProvider>
        <div className="min-h-screen bg-[#0B0C10]">
          <div className="pb-20 lg:mr-80 lg:pb-0">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/order" element={<Order />} />
                <Route path="/private-events" element={<PrivateEvents />} />
                <Route path="/business" element={<Business />} />
                <Route path="/album" element={<Album />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/payment/bank/:orderId" element={<BankPayment />} />
                <Route path="/admin/payments" element={<AdminPayments />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Player />
          <Toaster theme="dark" position="bottom-left" toastOptions={TOAST_OPTIONS} />
        </div>
      </PlayerProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
